export default __webpack_public_path__ + "static/shopify_logo-86884aeb72a2b9ec11a83602e066b591.webp";